import type {MutableRefObject, ReactNode} from 'react';
import {useRef} from 'react';

import {useListKeysControl} from './useListKeysControl';

type NavigationListProps = {
    keys: string[];
    onEnter?: (key: string) => void;
    isolated?: boolean;
    submitControls?: string[];
    children: ({refs, activeId}: {refs: MutableRefObject<Record<string, HTMLDivElement>>; activeId: string | undefined}) => ReactNode;
}

export const NavigationList = ({children, onEnter, keys, isolated, submitControls}: NavigationListProps) => {
    const suggestionRefs = useRef<Record<string, HTMLDivElement>>({});

    const {activeKey} = useListKeysControl({keys, refs: suggestionRefs, onEnter, isolated, submitControls});

    return <>{children({refs: suggestionRefs, activeId: activeKey})}</>;
};
